import React from 'react';

const steps = [
  {
    title: "Book in Just 2 Tabs",
    description: "Easily book your taxi in just two simple steps. Select your destination and confirm your ride."
  },
  {
    title: "Get a Driver",
    description: "Receive a driver assignment within minutes. We match you with the nearest available driver."
  },
  {
    title: "Track Your Driver",
    description: "Monitor your driver’s real-time location on the map and stay updated on their estimated arrival time."
  },
  {
    title: "Arrive Safely",
    description: "Enjoy a smooth and safe ride to your destination. Our drivers ensure a comfortable journey."
  }
];

const stepStyle = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  margin: '10px',
  padding: '20px',
  border: '1px solid #ddd',
  borderRadius: '8px',
  boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
};

const titleStyle = {
  fontSize: '1.0rem',
  fontWeight: 'bold',
  marginBottom: '5px',
};

const descriptionStyle = {
  fontSize: '1rem',
  textAlign: 'center',
};

const StepsComponent = () => {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
      {steps.map((step, index) => (
        <div key={index} style={stepStyle}>
          <div style={titleStyle}>{step.title}</div>
          <p style={descriptionStyle}>{step.description}</p>
        </div>
      ))}
    </div>
  );
};

export default StepsComponent;
